/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";

export class SpinStart implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;

    /**
     * @constructs
     * @param stagger
     * @param abortStagger
     */
    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedServerData): Timeline | null {
        const tl: TimelineLite = new TimelineLite();

        // making sure to return straight away when next mode is gamble.
        if (data.nextMode === ImmortalFruitsGameMode.GAMBLE) {
            return tl;
        }

        tl.add(() => {
            if (SoundConfig.instance.REELS_SPIN_START) {
                SlotGame.sound.playEffect(SoundConfig.instance.REELS_SPIN_START[0]);
            }
        });

        return tl;
    }
}